<template>
  <aside>
    <div class="col-md-4">
      <h3>
        <i class="fa fa-credit-card"></i>Informações
      </h3>
      <dl>
        <dt>Acompanhante(s) selecionado(s)</dt>
        <dd>
          <ul class="list-group">
            <div v-for="issue in account.issuance" :key="issue.guest">
              <li class="list-group-item" v-if="!issue.isExtra">
                {{ issue.guest }}
                <button v-if="tabName != 'Conclusão'" type="button" 
                  @click="removeIssue(issue.id)" 
                  class="close" aria-hidden="true">&times;
                </button>
              </li>
            </div>
          </ul>
        </dd>
        <dt>ACOMPANHANTES EXTRAs:</dt>
        <dd>
          <ul class="list-group">
            <li class="list-group-item" v-if="user.participant.extras.bedroom">
              QUARTO EXTRA
              <button v-if="tabName !== 'Conclusão'" type="button"
                @click="user.participant.extras.bedroom = false" class="close" aria-hidden="true">&times;
              </button>
            </li>
            <div v-for="issue in extraGuests" :key="issue.guest">
              <li class="list-group-item" v-if="issue.isExtra">
                {{ issue.guest }}
                <button v-if="tabName !== 'Conclusão'" type="button"
                  @click="removeIssue(issue.id)" class="close" aria-hidden="true">&times;
                </button>
              </li>
                <li class="list-group-item" v-if="issue.extras.bedroom">
                QUARTO EXTRA
                <button v-if="tabName !== 'Conclusão'" type="button"
                  @click="removeExtraBedroom(issue)" class="close" aria-hidden="true">&times;
                </button>
              </li>
            </div>
          </ul>
        </dd>
        <!-- <dt>ACOMP. EXTRA (PASSAGENS):</dt>
        <dd>
          <ul class="list-group">
            <li class="list-group-item">
              Serão informadas posteriormente pela Origami
            </li>
          </ul>
        </dd> -->
      </dl>
      <div class="disabled">
      <custom-button class="btn-block" v-if="false" myText="Pagar" 
        icon="credit-card-alt" pos="left" >
      </custom-button>
      </div>
    </div>
  </aside>
</template>

<script>
import _ from 'lodash';
export default {
  props: {
    participant: {
      type: Object,
      required: true
    },
    accountProp: {
      type: Object,
      required: true
    },
    tabName: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      user: this.participant,
      account: this.accountProp
    }
  },
  methods: {
    removeIssue: function (index) {
      this.$emit('handleRemovedIssue', index);
    },
    removeExtraBedroom: function (issue) {
      this.account.issuance.forEach(guest => {
        if (guest.id === issue.id) {
          guest.extras.bedroom = false
        }
      })
    }
  },
  computed: {
    extraGuests: function () {
      return _.sortBy(this.account.issuance.filter(o => o.isExtra === true), o => Number(o.age)).reverse();
    }
  },
  watch: {
    user: {
      handler: function (val) {
        this.$emit('handleUserChanged', val);
      },
      deep: true
    },
    account: function (val) {
      this.$emit('handleAccountChanged', val);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/FlightInfo.vue